"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const search_action_processor_1 = require("./search-action.processor");
class BlacklistProcessor extends search_action_processor_1.SearchActionProcessor {
    encodeRequestData(action) {
        return Object.assign(super.encodeRequestData(action), {
            [BlacklistProcessor.TERMS_MAP_FIELD]: action.terms,
            [BlacklistProcessor.LANG_MAP_FIELD]: action.filters.lang
        });
    }
    encodeRequestFilters(requestFilters) {
        requestFilters = Object.assign({}, requestFilters);
        const requestFiltersEncoded = {
            mode: 'list'
        };
        return Object.assign(super.encodeRequestFilters(requestFilters), requestFiltersEncoded);
    }
    decodeResponseDataItem(responseDataItem) {
        return Object.assign(super.decodeResponseDataItem(responseDataItem), {
            terms: responseDataItem[BlacklistProcessor.TERMS_MAP_FIELD],
            filters: {
                lang: responseDataItem[BlacklistProcessor.LANG_MAP_FIELD]
            }
        });
    }
    encodeRequestSortField(field) {
        field = field.replace('filters.', '');
        if (field === 'terms') {
            return BlacklistProcessor.TERMS_MAP_FIELD;
        }
        if (field === 'lang') {
            return BlacklistProcessor.LANG_MAP_FIELD;
        }
        return super.encodeRequestSortField(field);
    }
    encodeLangFilter(lang) {
        return {
            [BlacklistProcessor.LANG_MAP_FIELD]: lang
        };
    }
    decodeErrorFieldId(responseField) {
        const field = super.decodeErrorFieldId(responseField);
        if (field === BlacklistProcessor.TERMS_MAP_FIELD) {
            return 'terms';
        }
        if (field === BlacklistProcessor.LANG_MAP_FIELD) {
            return 'filters.lang';
        }
        return field;
    }
}
BlacklistProcessor.TERMS_MAP_FIELD = 'terms';
exports.BlacklistProcessor = BlacklistProcessor;
//# sourceMappingURL=data:application/json;base64,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